import React, { useEffect, useRef } from "react";
import { getPictureHandlerUrl } from "../../../helpers/Utils";
import styles from "./ActivityTooltip.module.css";

function ActivityTooltip({ activityData, handleMouseLeave }) {
  const {
    selectedActivity,
    activitiesList,
    speakersList,
    typesData,
    trackData,
  } = activityData;
  const { callerPosition } = selectedActivity;
  const activityToRender = getCompleteActivityData(
    selectedActivity,
    activitiesList,
    speakersList,
    trackData,
    typesData
  );
  const scrollRef = useRef(window.scrollY);
  const targetElementRef = useRef(null);
  const { activity, speakers, childActivities } = activityToRender;
  const { title, startDateTime, endDateTime, tracks, room } = activity;
  const date = new Date(startDateTime);
  const options = { day: "numeric", month: "short" };
  const shortMonthAndDate = date
    .toLocaleDateString("es-ES", options)
    .toUpperCase();

  const startTimeStr = startDateTime
    .split("T")[1]
    .split(":")
    .splice(0, 2)
    .join(":");
  const endTimeStr = endDateTime
    .split("T")[1]
    .split(":")
    .splice(0, 2)
    .join(":");

  // useEffect(() => {
  //   // Scroll to the top of the child component when it is mounted
  //   if (targetElementRef.current) {
  //     targetElementRef.current.scrollTop = 0;
  //   }
  // }, []);

  useEffect(() => {
    scrollRef.current = window.scrollY;
    const handleScroll = () => {
      console.log("handling the scroll");
      const { top, left, right } = callerPosition;
      const targetElement = targetElementRef.current;
      const { width: tooltipWidth, height: tooltipHeight } =
        targetElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const spaceToRight = viewportWidth - right;
      const spaceToLeft = viewportWidth - left;
      let y =
        viewportHeight - top > tooltipHeight
          ? top
          : viewportHeight - tooltipHeight;
      if (y < 0 || top < 0) {
        y = 0;
      }
      if (spaceToRight > tooltipWidth) {
        targetElement.style.left = right + 8;
      }
      if (spaceToRight < tooltipWidth && spaceToLeft > tooltipWidth) {
        targetElement.style.left = left - tooltipWidth - 8;
      }
      if (
        spaceToRight < tooltipWidth &&
        spaceToLeft < tooltipWidth &&
        spaceToRight > spaceToLeft
      ) {
        targetElement.style.left = "unset";
        targetElement.style.right = 8;
      } else {
        targetElement.style.left = 8;
        targetElement.style.right = "unset";
      }
      if (targetElement && !isNaN(scrollRef.current)) {
        console.log(
          "there is data to scroll",
          scrollRef.current,
          targetElement.style.top
        );
        const offset = window.scrollY - scrollRef.current;
        targetElement.style.top = `${y - offset}px`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [callerPosition]);

  return (
    <div
      className={styles.toolTipContainer}
      style={{ top: `${callerPosition.top}px` }}
      ref={targetElementRef}
      id="sessions-grid-view-details-tooltip"
    >
      <button className={styles.closeBtn} onClick={() => handleMouseLeave()}>
        <i className="simple-icon-close" />
      </button>
      <span>{tracks}</span>
      <div className={styles.activityWhenAndWhere}>
        <div>
          <i className="simple-icon-event" />
          <span>{shortMonthAndDate}</span>
        </div>
        <div>
          <i className="simple-icon-clock" />
          <span>{`${startTimeStr} - ${endTimeStr}`}</span>
        </div>
        <div>
          <i className="simple-icon-location-pin" />
          <span>{room}</span>
        </div>
      </div>
      <span className={styles.titleText}>{title}</span>
      <div className={styles.speakersContainer}>
        {speakers?.map((speaker) => (
          <SpeakerCard
            speaker={speaker}
            key={`speaker_card_${speaker.data.id}`}
          />
        ))}
      </div>
      <div className={styles.childActivitiesContainer}>
        {childActivities
          ?.sort(
            (a, b) =>
              a.activity.startDateTime.localeCompare(
                b.activity.startDateTime
              ) || a.activity.order.localeCompare(b.activity.order)
          )
          .map((child) => (
            <ChildActivity
              activityData={child}
              key={`child_activity_${child.activity.id}`}
            />
          ))}
      </div>
    </div>
  );
}

export default ActivityTooltip;

function getCompleteActivityData(
  activity,
  activitiesList,
  speakersList,
  tracksList,
  typesList,
  isChildActivity
) {
  const completeActivity = JSON.parse(JSON.stringify(activity));
  const { childActivitiesIds, speakerActivity, tracks } = completeActivity;
  let childActivities;
  if (!isChildActivity) {
    childActivities = childActivitiesIds
      .map((childId) =>
        activitiesList.find((activity) => activity.id == childId)
      )
      .filter((child) => Boolean(child));
    childActivities = childActivities.map((children) =>
      getCompleteActivityData(
        children,
        activitiesList,
        speakersList,
        tracksList,
        typesList,
        true
      )
    );
  }
  const speakers = speakerActivity.map((speakerInActivity) => {
    const { idSpeaker, speakerOrder, speakerRole } = speakerInActivity;
    const data = speakersList.find((speaker) => speaker.id == idSpeaker);

    return {
      data,
      role: speakerRole,
      order: speakerOrder,
    };
  });

  return {
    activity,
    speakers,
    childActivities,
  };
}

function SpeakerCard({ speaker }) {
  const { data, role } = speaker;
  const { firstName, lastName, title, country, pictureId } = data;

  return (
    <div className={styles.speakerCard} id="sessions-grid-view-speaker-card">
      <div className={styles.profilePicture}>
        <img src={getPictureHandlerUrl(pictureId)} />
      </div>
      <div className={styles.information}>
        <span className={styles.roleText}>{role}</span>
        <span className={styles.fullName}>{`${lastName}, ${firstName}`}</span>
        <span
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: title }}
        ></span>
        <span className={styles.country}>{country}</span>
      </div>
    </div>
  );
}

function ChildActivity({ activityData }) {
  const { activity, speakers } = activityData;
  const { title, startDateTime, endDateTime } = activity;
  const startTimeStr = startDateTime
    .split("T")[1]
    .split(":")
    .splice(0, 2)
    .join(":");
  const endTimeStr = endDateTime
    .split("T")[1]
    .split(":")
    .splice(0, 2)
    .join(":");
  return (
    <div
      className={styles.childActivityCard}
      key={`activity_child_card_${activity.id}`}
      id="sessions-grid-view-child-activity-card"
    >
      <div className={styles.timeColumn}>
        <div className={styles.timeBullet} />
        <div>{startTimeStr}</div>
      </div>
      <div className={styles.activityColumn}>
        <span dangerouslySetInnerHTML={{ __html: title }}></span>
        {speakers.map((speaker) => (
          <SpeakerCard
            speaker={speaker}
            key={`speaker_card_${speaker.data.id}`}
          />
        ))}
      </div>
    </div>
  );
}
